import { render, staticRenderFns } from "./CreateOrderTask.vue?vue&type=template&id=10f0dd74&scoped=true"
import script from "./CreateOrderTask.vue?vue&type=script&lang=js"
export * from "./CreateOrderTask.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderTask.vue?vue&type=style&index=0&id=10f0dd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0dd74",
  null
  
)

export default component.exports